import PropTypes from "prop-types";
import { TextField as Field, InputAdornment } from "@mui/material";
import { useController } from "react-hook-form";

//---------------------------------------------------------------------------------
TextField.propTypes = {
  control: PropTypes.object,
  style: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  helperText: PropTypes.string,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
};

//---------------------------------------------------------------------------------

export default function TextField({
  control,
  style,
  name,
  label,
  errorMsg,
  multiline,
  fullWidth,
  disabled,
  helperText,
  type,
  required,
  endAdornment,
  rules,
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: {
      ...(required ? { required } : {}),
      ...(rules || {}),
      // pattern: { value: /^\S+@\S+$/i, message: 'Eingabe besitzt kein gültiges E-Mail Format.' },
    },
    // rules: { required: true, pattern: /^\S+@\S+$/i },
  });

  const showErrorMessage = () => {
    if (error?.message) {
      return error.message;
    }
    if (errorMsg) {
      return errorMsg;
    }
    return "";
  };

  return (
    <Field
      label={label}
      variant="outlined"
      required={Boolean(required)}
      onChange={field.onChange} // send value to hook form
      onBlur={field.onBlur} // notify when input is touched/blur
      value={field.value} // input value
      name={field.name} // send down the input name
      inputRef={field.ref} // send input ref, so we can focus on input when error appear
      error={error && true}
      helperText={error ? showErrorMessage() : helperText}
      fullWidth={fullWidth}
      disabled={disabled}
      multiline={multiline}
      style={style}
      type={type}
      InputProps={{
        endAdornment: endAdornment && (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
      }}
    />
  );
}

TextField.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  style: PropTypes.object,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

TextField.defaultProps = {
  type: "text", // Hier den Standardwert festlegen
};
